<template>
<div>

    <div class="box box-primary">
        <div class="box-header with-border"> 
        <h3 class="box-title">Voucher</h3>
            <span class="">
                <router-link to="/receiptvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Receipt</router-link>
                <router-link to="/contravoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Contra</router-link>
                <router-link to="/journalvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Journal</router-link>
              </span>
            <div class="box-tools pull-right">
                <router-link to="/voucher" class="btn btn-xs btn-primary"><i class="fa fa-reply"></i> Back</router-link>
                <button type="button" @click="getBranch()" title="Reload Ledgers" class="btn btn-xs btn-default"><i class="fa fa-refresh"></i></button>
            <button type="button" data-widget="" class="btn btn-box-tool"><i class="fa fa-remove"></i></button>
            </div>
        </div>  
        <!----> 
        <section class="content">

            <div class="row">
          <div class="col-md-12 bg-green">
              <span class="pull-left">Accounting Voucher Creation</span> <center><strong>MICROFINANCE LIMITED</strong></center>
          </div>
          <div class="col-md-12" style="background-color: #FFFFD9;">
                <div class="col-md-6">
                    <div class="row">
                      <div class="col-sm-3">
                          <label>Branch <span class="red">*</span></label>
                      </div>
                      <div class="col-sm-3">
                          <select v-model="form.branch_id" @change="loadBranchData()" name="branch_id" class="form-control" :class="{'is-invalid': form.errors.has('branch_id')}" accesskey="b">
                              <option v-for="(branch, index) in branches" :key="index" :value="branch.id">{{branch.name}}</option>
                          </select>
                          <has-error :form="form" field="branch_id"></has-error>
                      </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-3">
                            <label>VoucherType <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-3">
                            <select v-model="form.voucherType" disabled name="voucherType" class="form-control" :class="{'is-invalid': form.errors.has('voucherType')}">
                                <option value="payment">Payment</option>
                            </select>
                            <has-error :form="form" field="voucherType"></has-error>
                        </div>
                        <div class="col-sm-3">
                            <strong>No:</strong>{{this.form.voucherNo}}
                            <has-error :form="form" field="voucherNo"></has-error>
                        </div>                        
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row">                      
                                <div class="col-sm-3">
                                    <label>Cr. Account <span class="red">*</span></label>
                                </div>
                                <div class="col-sm-6">
                                    <v-select :options="crledgers" label="name" name="cr_ledger" placeholder="Select" v-model="cr_ledger" style="background-color: white;" accesskey="l"></v-select>
                                    <has-error :form="form" field="cr_ledger"></has-error>
                                </div>
                            </div>
                            <div class="row">                          
                                <div class="col-sm-3"></div>
                                <div class="col-sm-3">
                                    <i>Cur Bal:<strong>{{cr_ledger.balanceAmt}} {{ (cr_ledger.balanceAmt>=0)?'Dr':'Cr' }}</strong></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="pull-right">
                        <div class="col-sm-4">
                            <label>Date <span class="red">*</span></label>
                        </div>
                        <div class="col-sm-8">
                            <input v-model="form.date" type="date" name="date" class="form-control" :class="{ 'is-invalid': form.errors.has('date') }" accesskey="d" />
                            <has-error :form="form" field="date"></has-error>
                          </div>
                    </div>
                </div>
                
                <div class="row">
                    <div class="col-sm-12">
                        <hr>
                        <div class="row">        
                            <form @submit.prevent="holdTempVoucher()">  
                                <div class="col-sm-1">
                                    <add-ledger></add-ledger>
                                </div>            
                                <div class="col-sm-2">
                                    <label>Dr. Account <span class="red">*</span></label>
                                </div>
                                <div class="col-sm-3">
                                    <v-select :options="drledgers" label="name" name="dr_ledger" placeholder="Select" v-model="dr_ledger" style="background-color: white;"></v-select>
                                    <has-error :form="form" field="dr_ledger"></has-error>
                                </div>                                
                                <div class="col-sm-2">
                                    <label>Amt <span class="red">*</span></label>
                                </div>
                                <div class="col-sm-3">
                                    <input v-model="amt" type="number" step=".01" name="amt" class="form-control" accesskey="n" />
                                    <has-error :form="form" field="amt"></has-error>                               
                                </div>
                                <div class="col-sm-1">
                                    <button type="submit" title="Submit" class="btn btn-sm btn-success" accesskey="s"><i class="fa fa-plus"></i></button>
                                </div>
                            </form>
                        </div>                        
                        <hr>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th width="80%">Particular</th>
                                    <th width="20%">Amount (Dr)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ledger, index) in holdVouchers" :key="index" >
                                    <td>
                                        {{ledger.branchLedger.name}}
                                        <br><i>Cur Bal:<strong>{{ledger.branchLedger.balanceAmt}} {{ (ledger.branchLedger.balanceAmt>=0)?'Dr':'Cr' }}</strong></i>
                                    </td>
                                    <td><strong>{{ledger.amt}}</strong> <a class="text-danger" @click="removeHoldVoucher(index)"><i class="fa fa-times"></i></a></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><hr><strong>Total: {{this.total}}</strong><hr><hr></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group">
                            <label>Narration</label>
                            <textarea v-model="form.narration" class="form-control"></textarea>
                        </div>
                        <button class="btn btn-success" @click.once="createVoucher()"><i class="fa fa-save"></i> Save</button>
                        <br>
                    </div>
                </div>
          </div>
          <hr>
      </div>


        </section>
    </div>



        
</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
import AddLedger from './AddLedger.vue'
export default {
  name: 'PaymentVoucher',
  mixins: [GetBranch],
  components: {
    'add-ledger': AddLedger
  },
  data () {
    return {
      branches: [],
      voucher: {},
      form: new Form({
        id: '',
        branch_id: null,
        voucherNo: null,
        date: '',
        voucherType: 'payment',
        narration: '',
        branchLedgers: [],
        status: ''
      }),
      drledgers: [],
      crledgers: [],
      holdVouchers: [],
      cr_ledger: {},
      dr_ledger: {},
      amt: null,
      total: 0
    }
  },
  methods: {
    holdTempVoucher () {
      if (jQuery.isEmptyObject(this.dr_ledger)) {
        Toast.fire({ icon: 'error', title: 'Please Select a Ledger Account' })
      } else if (this.amt == null || this.amt <= 0) {
        Toast.fire({ icon: 'error', title: 'Please select amt to ledger' })
      } else {
        var data = {'type': 'dr', 'branchLedger': this.dr_ledger, 'amt': this.amt}
        this.holdVouchers.push(data)
        this.total = _.sumBy(this.holdVouchers, function (o) { return parseFloat(o.amt) })
        this.dr_ledger = {}
        this.amt = null
      }
    },
    removeHoldVoucher (index) {
      this.holdVouchers.splice(index, 1)
      this.total = _.sumBy(this.holdVouchers, function (o) { return parsefloat(o.amt) })
    },
    createVoucher () {
      if (this.total <= 0) {
        Toast.fire({ icon: 'error', title: 'Please Select Ledger Account voucher amt should not be null' })
      } else if (jQuery.isEmptyObject(this.cr_ledger)) {
        Toast.fire({ icon: 'error', title: 'Please Select a Cr Ledger Account' })
      } else if (this.holdVouchers.length <= 0) {
        Toast.fire({ icon: 'error', title: 'Please select amt to ledger' })
      } else {
        var data = {'type': 'cr', 'branchLedger': this.cr_ledger, 'amt': this.total}
        this.form.branchLedgers.push(data)
        // alert('Hell' + this.form.branchLedgers.length)
        // Add other voucher to ledgers
        _.forEach(this.holdVouchers, function (value) {
          this.form.branchLedgers.push(value)
        }.bind(this))
        // Add Voucher to Server
        this.$axios
          .post('voucher', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then(() => {
            Toast.fire({icon: 'success', title: 'Voucher Added Successfully'})
            // location.reload()
            this.$router.push({name: 'voucher'})
          })
          .catch(function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this))
      }
    },
    loadBranchData () {
      this.holdVouchers = []
      this.total = 0
      this.$axios
        .get('branchledger?all=all&status=active&multiple_group_not_id[]=1&multiple_group_not_id[]=2&multiple_group_not_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.drledgers = data.data
          $.each(this.drledgers, function (key, value) {
            this.drledgers[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      this.$axios
        .get('branchledger?all=all&status=active&multiple_group_id[]=1&multiple_group_id[]=2&multiple_group_id[]=4&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.crledgers = data.data
          $.each(this.crledgers, function (key, value) {
            this.crledgers[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
      this.$axios
        .get('voucherseries', {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.form.voucherNo = parseInt(data.data.paymentSeries) + 1
          if (data.data.paymentIncludeYear === 'true') {
            this.form.voucherNo = '' + new Date().getFullYear() + this.form.voucherNo
          }
          if (data.data.paymentPrefix !== '') {
            this.form.voucherNo = '' + data.data.paymentPrefix + this.form.voucherNo
          }
        }).catch(function (error) { console.log(error) })
    }
    // getBranch () {
    //   this.$axios
    //     .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
    //     .then((data) => {
    //       this.branches = data.data
    //     }).catch(function (error) { console.log(error) })
    // }
  },
  created () {
    this.getBranch()
    Fire.$on('AfterCreate', () => {
      this.getBranch()
    })
    // Fire.$emit('AfterCreate')
    var date = new Date()
    var day = date.getDate()
    var month = date.getMonth() + 1
    var year = date.getFullYear()
    if (month < 10) month = '0' + month
    if (day < 10) day = '0' + day
    var today = year + '-' + month + '-' + day
    this.form.date = today
    // document.getElementById('theDate').value = today
  }
}
</script>

<style scoped>
.help-block {
    color:red;
}
</style>



// WEBPACK FOOTER //
// PaymentVoucher.vue?3356ea57